export { default } from "./SlotTooltip.js";